<template>
  <!-- :fullscreen="true" -->

  <el-dialog
    title="历史记录"
    :visible.sync="dialogVisible"
    width="80%"
    @close="handleDialogClose"
    :fullscreen="fullQ"
    :before-close="handleBeforeClose"
    :close-on-click-modal="false"
  >
    <template #title>
      <span>历史记录</span>
      <!-- 全屏按钮 -->
      <el-button
        class="fullscreen-btn"
        icon="el-icon-full-screen"
        @click="toggleFullscreen"
        size="small"
        style="float: right; margin-top: 5px"
      ></el-button>
    </template>
    <!-- 表格展示 -->
    <el-table
      ref="tableRef"
      v-loading="tableLoading"
      highlight-current-row
      :border="true"
      :data="tableData"
      :header-cell-style="{ background: '#EFEFEF', color: '#000' }"
      :current-page="pageNum"
      :page-size="pageSize"
      :total="totalItems"
    >
      <el-table-column label="序号" width="60px" align="center">
        <template slot-scope="scope">
          <span :class="scope.row.isChaoQi ? 'ischaoQi' : ''">
            {{ getColumnIndex(scope.$index) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="partCode"
        label="配件代码"
        min-width="160px"
        show-overflow-tooltip
        align="center"
      ></el-table-column>
      <el-table-column
        prop="partName"
        label="配件名称"
        min-width="120px"
        show-overflow-tooltip
        align="center"
      ></el-table-column>
      <el-table-column
        prop="supplierName"
        label="供应商名称"
        min-width="120px"
        show-overflow-tooltip
        align="center"
      ></el-table-column>
      <el-table-column
        prop="purchasePrice"
        label="采购价"
        min-width="120px"
        show-overflow-tooltip
        align="center"
      ></el-table-column>
      <el-table-column
        prop="memberName"
        label="更新人员"
        min-width="180px"
        show-overflow-tooltip
        align="center"
      ></el-table-column>
      <el-table-column
        prop="updateTime"
        label="更新时间"
        min-width="150px"
        show-overflow-tooltip
        align="center"
      ></el-table-column>
      <el-table-column
        prop="yearsMonth"
        label="年月"
        min-width="120px"
        show-overflow-tooltip
        align="center"
      ></el-table-column>
    </el-table>

    <!-- 分页控件 -->
    <div class="fenye" v-if="totalItems > 0">
      <pagination
        :total="totalItems"
        :page.sync="pageNum"
        :limit.sync="pageSize"
        @pagination="handlePageSizeChange"
      />
    </div>
  </el-dialog>
</template>

<script>
import { oldCostPriceMaintenance } from "@/api/cost.js";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    queryParams: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      fullQ: false, //全屏
      dialogVisible: this.visible, // 弹窗显示控制
      tableLoading: false, // 表格加载状态
      tableData: [], // 表格数据
      pageNum: 1, // 当前页码，默认值为1
      pageSize: 10, // 每页条数，默认值为10
      totalItems: 0 // 数据总数
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.fetchData(); // 弹窗显示时，获取数据
      }
    },
    queryParams: {
      handler(newQueryParams) {
        this.pageNum = 1; // 每次查询条件变化时，重置为第一页
        this.fetchData(); // 查询条件变化时重新加载数据
      },
      deep: true // 深度观察queryParams，确保嵌套属性的变化也能触发
    },
  },
  methods: {
    getColumnIndex(index) {
      return index + 1 + (this.pageNum - 1) * this.pageSize;
    },
    // 发送请求并获取数据
    async fetchData() {
      try {
        this.tableLoading = true;
        const response = await oldCostPriceMaintenance({
          data: this.queryParams, // 传递查询条件
          page: {
            pageNum: this.pageNum,
            pageSize: this.pageSize
          }
        });
        const { data } = response;
        this.tableData = data.records || []; // 根据实际响应调整字段名
        this.totalItems = data.count || 0; // 更新总数据数
      } catch (error) {
        console.error("数据请求失败:", error);
      } finally {
        this.tableLoading = false;
      }
    },
    handlePageSizeChange(val) {
      this.pageNum = val.page;
      this.pageSize = val.limit;
      this.fetchData();
    },
    // 弹窗关闭时重置条件
    handleDialogClose() {
      // this.$refs.tableRef.clearValidate();
      this.pageNum = 1;
      this.$emit("update:visible", false); // 通知父组件关闭弹窗
      this.fullQ = false;
    },
    // 弹窗关闭前
    handleBeforeClose(done) {
      done(); // 这里可以执行一些清理操作
    },
    toggleFullscreen() {
      // 切换全屏状态
      this.fullQ = !this.fullQ;
    }
  },
  created() {
    if (this.visible) {
      this.fetchData(); // 在组件创建时默认加载数据
    }
  }
};
</script>

<style scoped>
.fullscreen-btn {
  margin: -2px 30px 0 0 !important;
  border: none !important;
  padding: 5px;
}
</style>
